import { GQL_ID } from '@@types'
import { gql, useMutation } from '@apollo/client'

const CLEAR_CART_MUTATION = gql`
  mutation ClearCart($shopId: ID!) {
    clearCart(shop_id: $shopId)
  }
`

export interface ClearCartVariables {
  shopId: GQL_ID
}

export interface ClearCartResponse {
  clearCart: boolean
}

export function useMutateClearCart () {
  return useMutation<ClearCartResponse, ClearCartVariables>(CLEAR_CART_MUTATION, {
    // Очищаем Apollo кэш для cartInfo после успешной очистки корзины
    update: (cache) => {
      cache.evict({ fieldName: 'cartInfo' })
      cache.evict({ fieldName: 'syncCart' })
      cache.gc()
    },
  })
}
